import React, { useEffect } from 'react';

const HetznerServiceIncludedSection = () => {
const includedServices = [
{ text: "Cloud infrastructure assessment & planning", delay: "150ms" },
{ text: "Server deployment & configuration", delay: "190ms" },
{ text: "Cloud migration with minimal downtime", delay: "230ms" },
{ text: "Network & security configuration", delay: "270ms" },
{ text: "SSL certificates & secure access setup", delay: "310ms" },
{ text: "Backup & disaster recovery planning", delay: "350ms" },
{ text: "Performance optimization & resource tuning", delay: "390ms" },
{ text: "Infrastructure monitoring & alerting", delay: "430ms" },
{ text: "Security hardening & best practices", delay: "470ms" },
{ text: "Documentation & knowledge transfer", delay: "510ms" },
{ text: "DevOps automation & CI/CD integration", delay: "550ms" },
{ text: "Dedicated technical support & maintenance", delay: "590ms" }
];


  useEffect(() => {
    const animateElements = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight - 100;
        if (isVisible) {
          element.classList.add('animated');
        }
      });
    };

    animateElements();
    window.addEventListener('scroll', animateElements);
    
    return () => {
      window.removeEventListener('scroll', animateElements);
    };
  }, []);

  return (
    <section className="relative py-8 md:py-10 bg-blue-500 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gray-900"></div>
        <div 
          className="absolute inset-0" 
          style={{ 
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundRepeat: 'repeat'
          }}
        ></div>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-white mb-4">
            Included with Every Project
          </h3>
          <p className="text-gray-300 text-base">
            End-to-end cloud services with no hidden fees or unexpected costs.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {includedServices.map((service, index) => (
            <div 
              key={index}
              className="flex items-center space-x-3 group hover:translate-x-1 transition-all duration-300 animate-on-scroll"
              style={{ transitionDelay: service.delay }}
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                strokeWidth="1.5" 
                stroke="currentColor" 
                className="w-5 h-5 text-green-500 flex-shrink-0 group-hover:scale-110 transition-transform duration-300"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" 
                />
              </svg>
              <span className="text-white text-sm">{service.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HetznerServiceIncludedSection;